<template>
<section >
    <div class="toppurple ios ">
    <div class="iosversion">دانلود مستقیم نسخه ios</div>
</div>
<div class="tutorial-container">
    <div class="tutorial-steps" style="margin-top:40px;">
            <div class="tutorial-level" style="margin-top:0">مرحله‌ ۱/۶</div>
            <br>
            <div class="tutorial-desc">روی آیکون دریافت مستقیم کلیک کنید.</div>
            <a title='7030' class="tutorial-pic" target="_blank" href="https://7030.ir/dl/ios/latest" style="margin-top:auto"><img src="/images/tutorials/ios-download.png" alt="ios download"></a>
    </div>
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۲/۶</div>
        <div class="tutorial-desc">ابتدا ازسایت 7030.ir دریافت مستقیم اپلیکیشن را لمس کرده سپس دکمه‌ی "open" را انتخاب کنید.</div>
        <div class="tutorial-pic"><img src="/images/tutorials/iosstep1.png" alt="ios tutorial"></div>
    </div> 
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۳/۶</div>
        <div class="tutorial-desc">سپس "install" رو بزنید و منتظر باشید نصب اپلیکیشن به اتمام برسه.</div>
        <div class="tutorial-pic"><img src="/images/tutorials/iosstep2.png" alt="ios tutorial"></div>
    </div> 
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۴/۶</div>
        <div class="tutorial-desc">به منوی تنظیمات رفته، "general" را لمس کرده سپس در صفحه‌ی بعدی "device managment" را بزنید</div>
        <div class="tutorial-pic"><img src="/images/tutorials/iosstep3.png" alt="ios tutorial"></div>
    </div> 
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۵/۶</div>
        <div class="tutorial-desc">"TIMESSQUERE(L.L.C)" را انتخاب کنید.</div>
        <div class="tutorial-pic"><img src="/images/tutorials/iosstep4.png" alt="ios tutorial"></div>
    </div> 
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۶/۶</div>
        <div class="tutorial-desc">در اخر گزینه‌ي "trust" را انتخاب کنید.</div>
        <div class="tutorial-pic"><img src="/images/tutorials/iosstep5.png" alt="ios tutorial"></div>
    </div> 
</div>

</section>
</template>

<script>

export default {
    data(){
        return{       
        }
    },
    components: {

    },
    methods: {
        
    },
    mounted(){
        this.$store.state.loading=false        
    }
}
</script>

<style>
 
</style>
